// Inline style for a .tag-chip tinted with a color (tag library color, rating level color): a soft
// background wash and a stronger border, readable over dark and light themes. Accepts #rrggbb and
// rgb()/rgba() (the color picker's alpha mode); the color's own alpha is ignored so the tint stays
// consistent. Falls back to the neutral chip styling for missing or unrecognized colors.
export function tagChipStyle(color) {
  let r, g, b
  const rgb = typeof color === 'string' ? color.match(/^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})/) : null
  if (color && /^#[0-9a-fA-F]{6}$/.test(color)) {
    r = parseInt(color.substr(1, 2), 16)
    g = parseInt(color.substr(3, 2), 16)
    b = parseInt(color.substr(5, 2), 16)
  } else if (rgb) {
    [r, g, b] = [rgb[1], rgb[2], rgb[3]].map(Number)
  } else {
    return {}
  }
  return {
    backgroundColor: `rgba(${r}, ${g}, ${b}, 0.15)`,
    borderColor: `rgba(${r}, ${g}, ${b}, 0.4)`,
  }
}
